import { ResultCardBodyField } from '../search-result.model';
import { IField } from '../services/apiServices';

// columnKeys for object type — adjust if the API uses different keys
const OBJECT_TYPE_KEYS = ['objectDefinition', 'objectdefination', 'objectType'];

export const getResultCardContent = (
  result: IField[],
  moduleNameProps: string,
  objectdefination?: string,
  topLevelName?: string,
  topLevelLabel?: string,
  topLevelDetailViewName?: string
) => {
  const moduleName = moduleNameProps;
  let detailViewName: string | null = topLevelDetailViewName ?? null;
  let resultLabel: string | null = topLevelLabel ?? null;
  let resultTitle = null;
  let resultName: string | null = topLevelName ?? null;
  let modifiedAtDate = null;
  let createdAtDate = null;
  let version = null;
  let objectType: string | null = objectdefination ?? null;
  const cardHeaderContent: Record<string, string> = {};
  const cardBodyContent: Record<string, ResultCardBodyField> = {};

  for (const field of result) {
    const {
      columnKey,
      columnValue,
      columnName,
      canUseInHyperLink,
      detailViewName: detailViewNameProps,
    } = field;

    detailViewName = detailViewNameProps;

    switch (columnKey) {
      case 'label':
        resultLabel = columnValue ?? resultLabel;
        break;
      case 'title':
        resultTitle = columnValue ?? resultTitle;
        break;
      case 'modifiedAtUtc':
        modifiedAtDate = columnValue ?? modifiedAtDate;
        break;
      case 'createdAtUtc':
        createdAtDate = columnValue ?? createdAtDate;
        break;
      case 'name':
        resultName = columnValue ?? resultName;
        break;
      case 'version':
        version = columnValue ?? version;
        break;
      default:
        if (OBJECT_TYPE_KEYS.includes(columnKey) && columnValue) {
          objectType = columnValue;
        } else if (columnName && columnValue) {
          if (canUseInHyperLink) {
            cardHeaderContent[columnName] = columnValue;
          } else {
            cardBodyContent[columnKey] = {
              label: columnName,
              value: columnValue,
            };
          }
        }
        break;
    }
  }

  return {
    moduleName,
    objectType,
    detailViewName,
    resultLabel,
    resultTitle,
    resultName,
    modifiedAtDate,
    createdAtDate,
    version,
    cardHeaderContent,
    cardBodyContent,
  };
};
